import { BREAKPOINTS } from 'shared/styles/base';
import get from 'lodash/get';
import { generateTrackingUrl } from 'shared/components/AdPlatformWidgets/helpers';
import { getOptimisedImageUrl } from 'shared/helpers/utils';
import { IWidgetItems } from 'shared/components/AdPlatformWidgets/types';

export const getCarouselProps = (width: number) => {
  switch (true) {
    case width < 1110: {
      return {
        slideWidth: 278,
        slideHeight: 543,
        slidesToMove: 1,
        slidesToShow: 3,
      };
    }

    case width < 1150: {
      return {
        slideWidth: 228,
        slideHeight: 523,
        slidesToMove: 2,
        slidesToShow: 4,
      };
    }

    case width < 1200: {
      return {
        slideWidth: 238,
        slideHeight: 523,
        slidesToMove: 2,
        slidesToShow: 4,
      };
    }

    default: {
      return {
        slideWidth: 258,
        slideHeight: 503,
        slidesToMove: 2,
        slidesToShow: 4,
      };
    }
  }
};

export const getProductCss = (deviceWidth: number) => {
  switch (true) {
    case deviceWidth < BREAKPOINTS.MOBILE: {
      const width = deviceWidth / 2 - 15;
      const margin = 10;
      return {
        width,
        margin,
      };
    }

    case deviceWidth < BREAKPOINTS.TABLET: {
      const width = deviceWidth / 2 - 40;
      const margin = 15;
      return {
        width,
        margin,
      };
    }

    default: {
      const width = deviceWidth / 3 - 40;
      const margin = 15;
      return {
        width,
        margin,
      };
    }
  }
};

export const getWidgetItemParams = (
  widgetItem: IWidgetItems,
  width: number,
  inventoryName: string
) => {
  const imageSource = get(widgetItem, 'children.0.source.Web', '');
  const bannerAspectRatio = get(widgetItem, 'children.0.source.Web_aspect_ratio', 1);
  const bannerOriginalImage = get(widgetItem, 'children.0.source.Web', '');

  const bannerActionUrl = generateTrackingUrl(
    widgetItem.parameters.web_action_url,
    inventoryName,
    widgetItem.positionInParent,
    widgetItem.parameters.tracking_parameters
  );

  return {
    source: getOptimisedImageUrl(imageSource, {
      width: width,
      e: 'sharpen',
    }),
    aspect_ratio: bannerAspectRatio,
    originalSource: bannerOriginalImage,
    action_url: bannerActionUrl,
  };
};
